module.exports = __webpack_public_path__ + "media/dark/key-delete-517fbf84.svg";